import { render } from "./TenantNotActivated.vue?vue&type=template&id=1a8086fe"
import script from "./TenantNotActivated.vue?vue&type=script&lang=js"
export * from "./TenantNotActivated.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__